<template>
    <EmployeeLink v-if="Number(userId) > 0" :user-id="userId" :fallback="name" compact icon-only
        class="employee-selection-preview" />
</template>
<script>
import EmployeeLink from './EmployeeLink.vue';
export default {
    components: {EmployeeLink},
    props: {userId: {type: [Number, String], default: null}, options: {type: Array, default: () => []}},
    computed: {
        name() {
            const option = this.options.find(row => row && String(row.value) === String(this.userId));
            return option && option.text || 'Выбранный сотрудник';
        }
    }
};
</script>
<style scoped>
.employee-selection-preview { margin: 4px 8px; }
</style>
